import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/plugins/vant.js";
import "@/plugins/easy-table";
import "vant/lib/index.css"; // 引入vant样式表
import "@/plugins/clipboard.js";
import "@/styles/index.less";
import { downBlobFilePost } from "@/util/tools";
import BasicContainer from "@/components/basic-container";
import echarts from "./util/echarts";
import { enableInlinePxToVw } from "@/util/inlinePx2vw";
import Vconsole from 'vconsole'

Vue.prototype.$echarts = echarts;
Vue.component("BasicContainer", BasicContainer);
Vue.prototype.downBlobFilePost = downBlobFilePost;

Vue.config.productionTip = false;
Vue.config.ignoredElements = ["wx-open-launch-weapp"]; // 忽略开放标签名检查
if (location.protocol !== "https:") {
  // 测试环境启用vconsole
  new Vconsole()
}

// 启用行内 style 的 px -> vw 运行时转换（仅静态数值）
enableInlinePxToVw({
  designWidth: 750,
  secondaryWidth: 375,
  // 根据你的 class 命名规则调整 secondaryMatch
  secondaryMatch: /^(van-|vant-)/,
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
